// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'
import { buttonFields } from '../elements/buttonFragment.graphql'
import { linkFields } from '../elements/linkFragment.graphql'

export const sectionUspFields = gql`
  fragment sectionUspFields on SectionUspRecord {
    modelApiKey: _modelApiKey
    title
    usp {
      title
      description {
        value
      }
      id
      icon
    }
    button {
      ...buttonFields
    }
    ctaText: cta
    ctaLink {
      ...linkFields
    }
    background
  }
  ${buttonFields}
  ${linkFields}
`
